var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiot3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "974.388px",
    height: "1000px",
    viewBox: "0 0 974.388 1000",
    enableBackground: "new 0 0 974.388 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#D13839",
    points: "614.699,0 0,290.379 95.062,727.955 220.447,727.955 198.79,414.942 218.027,408.978  293.426,727.955 423.699,727.955 418.862,346.671 438.109,340.707 504.009,727.955 641.926,727.955 674.456,267.393  693.692,261.428 727.836,727.955 910.19,727.955 974.388,87.508  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D13839",
    points: "509.443,907.093 463.992,789.998 902.341,812.533 883.547,1000  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiot3);
export default __webpack_public_path__ + "static/media/riot3.46f25e944085365be022bec6dffb1bb2.svg";
export { ForwardRef as ReactComponent };